"use client";

import React from "react";
import Image from "next/image";
import { LoginForm } from "@/components/login-form";
import LoginRightPane from "./LoginRightPane";
import "./login.css";
import mic from "../../../../public/img/mic.svg";

export default function ModernLoginMain() {
  return (
    <div className="ava-login-shell grid lg:h-screen min-h-screen lg:grid-cols-[1fr_1.05fr] lg:overflow-hidden">
      {/* Left — form pane (cream paper) */}
      <div className="ava-login-left flex flex-col gap-3 p-6 md:p-8 lg:overflow-y-auto">
        <div className="flex justify-center gap-2 md:justify-start">
          <a href="/" className="flex items-center gap-2 font-medium">
            <div className="flex h-8 w-8 items-center justify-center rounded-md bg-blue-600 shadow-[0_4px_12px_rgba(37,99,235,0.30)]">
              <Image
                src={mic}
                alt="AVA"
                width={16}
                height={16}
                className="h-4 w-4 filter brightness-0 invert"
              />
            </div>
            <span className="text-lg font-semibold tracking-tight">AVA</span>
          </a>
        </div>

        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md">
            <LoginForm />

            <div className="mt-8 text-center text-xs text-muted-foreground">
              By continuing, you agree to AVA&apos;s{" "}
              <a
                href="/terms"
                className="underline underline-offset-4 hover:text-primary"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="/privacy"
                className="underline underline-offset-4 hover:text-primary"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>

        <footer className="flex justify-between items-center text-xs text-gray-500 pt-2">
          <span>© 2026 AVA</span>
          <span className="space-x-2">
            <a href="/contact" className="hover:text-gray-800">Help</a>
            <span>·</span>
            <a href="/privacy" className="hover:text-gray-800">Privacy</a>
            <span>·</span>
            <a href="/terms" className="hover:text-gray-800">Terms</a>
          </span>
        </footer>
      </div>

      {/* Right — animated phone pane (hidden on mobile) */}
      <div className="hidden lg:block relative">
        <LoginRightPane />
      </div>
    </div>
  );
}
